









































































import { Employe } from "../../models/Employe";
import PlanningListDayDetail from "./PlanningListDayDetail.vue";
import { EmployeApi } from "../../api/EmployeApi";
import ConfirmSuppression from "../../core/Modals/ConfirmSuppression";

export default {
    name: "PlanningsListDetail",
    components: { PlanningListDayDetail },
    props: {
        planning: Employe.Planning,
    },
    data() {
        return {
            EmployeApi: new EmployeApi(),
            EWorkingHourDay: Employe.EWorkingHourDay,
        };
    },
    methods: {
        editPlanning() {
            this.$emit("edit-planning", this.planning.id);
        },
        deletePlanning() {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer ce planning ?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.EmployeApi.removePlanning(
                    self.planning.employe_id,
                    self.planning.id,
                    raison
                )
                    .then(function () {
                        self.$emit("planning-deleted");
                    })
                    .catch(function () {
                        swal(
                            "Le planning n'a pas pu être supprimé.",
                            "",
                            "error"
                        );
                    });
            });
        },
    },
};
